export default "__VITE_ASSET__4443e133__"